import React, { useState } from 'react';

const EMOJI_CATEGORIES = {
  Logistics: ['📦', '🚚', '✈️', '🚢', '📋', '✅', '⚠️', '🚨', '⏳', '📍', '🏭', '📄', '🏷️', '❄️'],
  Reactions: ['👍', '👎', '❤️', '🔥', '🎉', '👏', '🚀', '💯', '⭐', '🙌', '👌', '🎯'],
  Smiles: ['😀', '😃', '😄', '😂', '😊', '😎', '🤔', '🤝', '🙏', '💪', '👀', '💡', '✨', '👋']
};

export default function EmojiPickerPopover({ onSelect, onClose }) {
  const [activeTab, setActiveTab] = useState('Logistics');

  return (
    <div className="absolute bottom-14 left-2 z-50 bg-white rounded-xl shadow-2xl border border-gray-200 p-3 w-72 animate-in fade-in zoom-in-95 duration-150">
      {/* Category Tabs */}
      <div className="flex border-b border-gray-100 pb-2 mb-2 gap-1">
        {Object.keys(EMOJI_CATEGORIES).map(cat => (
          <button
            key={cat}
            onClick={() => setActiveTab(cat)}
            className={`px-2.5 py-1 text-xs font-semibold rounded-lg transition-colors ${
              activeTab === cat
                ? 'bg-blue-50 text-blue-700 font-bold'
                : 'text-gray-500 hover:bg-gray-50'
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Emoji Grid */}
      <div className="grid grid-cols-7 gap-1 max-h-48 overflow-y-auto p-1">
        {EMOJI_CATEGORIES[activeTab].map(emoji => (
          <button
            key={emoji}
            onClick={() => {
              onSelect(emoji);
              onClose();
            }}
            className="w-8 h-8 flex items-center justify-center text-lg rounded-lg hover:bg-gray-100 transition-transform active:scale-125"
            title={emoji}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
}
